import {Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {PermissionsService} from "../permissions/permissions.service";
import {SharedService} from "../shared/shared.service";

@Injectable({
    providedIn: 'root'
})
export class UserGuard implements CanActivate {
    constructor(
        private router: Router,
        private featureFlagService: PermissionsService,
        private sharedService: SharedService
    ) {
    }

    canActivate(): boolean {
        const languageData = this.sharedService.getLanguageData();
        if (languageData === true) {
            this.sharedService.setLanguageData(false);
            return true;
        }

        const navigation = this.router.getCurrentNavigation();
        const state = navigation?.extras.state as any;

        const ffOn = this.featureFlagService.isFeatureActivated('ent-10781-signup-improvements');

        let hasValidAccess: boolean;
        if (ffOn) {
            const stored = localStorage.getItem('signupUserData');
            const storedData = stored ? JSON.parse(stored) : null;
            const storedDataValid = storedData?.email && storedData?.uuid &&
                storedData?._expires && Date.now() <= storedData._expires;
            hasValidAccess = !!(state?.email && state?.uuid) || !!storedDataValid;
        } else {
            hasValidAccess = !!(state?.email && state?.uuid);
        }

        if (!hasValidAccess) {
            window.location.href = '/login';
            return false;
        }

        return true;
    }
}
